var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suggested-spaces"},[(_vm.listings && _vm.listings[0])?_vm._l((_vm.listings[0].node.listings.edges),function(space){return _c('SpaceCard',{key:space.node.id,attrs:{"space":space.node,"linkType":'routerLink',"user":_vm.user}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }